import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface NoResultsProps {
  className?: string;
}

export const NoResults: FC<NoResultsProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex h-full min-h-64 w-full items-center justify-center text-muted-foreground text-sm',
        className
      )}>
      {t('general.fallback.noResults')}
    </div>
  );
};
